var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        attrs: {
          type: "tabcard",
          align: "left",
          tabItems: _vm.tabItems,
          inlineLabel: true,
          dense: true,
          height: "700px",
        },
        on: {
          "update:tabItems": function ($event) {
            _vm.tabItems = $event
          },
          "update:tab-items": function ($event) {
            _vm.tabItems = $event
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  key: tab.key,
                  tag: "component",
                  attrs: {
                    moc: _vm.moc,
                    relatedWork: tab.relatedWork,
                    disabled: _vm.disabled,
                  },
                  on: {
                    "update:moc": function ($event) {
                      _vm.moc = $event
                    },
                    "update:relatedWork": function ($event) {
                      return _vm.$set(tab, "relatedWork", $event)
                    },
                    "update:related-work": function ($event) {
                      return _vm.$set(tab, "relatedWork", $event)
                    },
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }